import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FormControl } from "@material-ui/core";
import TableHeader from "../../../../components/Table/TableHeader";
import TablePagination from "../../../../components/Table/TablePagination";
import InputSearch from "../../../../components/InputSearch";
import "./styles.scss";

const tabelaColunas = [
  "Nº",
  "ID",
  "TP",
  "Data/hora de envio",
  "Nome Comprador",
  "CNPJ",
  "E-mail",
  "Celular",
  "Status",
  "Ações",
];

const ListGestaoPedidos = ({ response, buscar, busca, mudarPagina }) => {
  const history = useHistory();
  const [modalData, setModalData] = useState({
    showModal: false,
  });
  const [novaLista, setNovaLista] = useState([]);
  const gotoDet = (id) => {
    history.push(`/gestaoPedidos/editar/${id}`);
  };

  const formatarData = (value) => {
    const data = new Date(value);
    return `${data.toLocaleDateString()} ${data.toLocaleTimeString()}`;
  };

  const handleCloseModal = () => {
    setModalData({ showModal: false });
  };
  useEffect(() => {
    setNovaLista(response?.lista);
  }, [response]);

  return (
    <div>
      <div className="row justify-content-end">
        <div className="col-md-3 mt-3">
          <FormControl>
            <InputSearch buscar={buscar} buscaPor={busca} />
          </FormControl>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mt20">
          <div className="table-responsive gestao-pedidos-lista">
            <table className="table table-sm table-striped ">
              <thead>
                <tr>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.codigo - b.codigo);
                      const isReversed =
                        novaLista[0].codigo === sorted[0].codigo;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Nº
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.codigoOportunidade - b.codigoOportunidade
                      );
                      const isReversed =
                        novaLista[0].codigoOportunidade ===
                        sorted[0].codigoOportunidade;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    ID
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.tp - b.tp);
                      const isReversed = novaLista[0].tp === sorted[0].tp;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    TP
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.dataCadastro - b.dataCadastro
                      );
                      const isReversed =
                        novaLista[0].dataCadastro === sorted[0].dataCadastro;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Data/hora de envio
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.nomeCompleto - b.nomeCompleto
                      );
                      const isReversed =
                        novaLista[0].nomeCompleto === sorted[0].nomeCompleto;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Nome Comprador
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.cnpj - b.cnpj);
                      const isReversed = novaLista[0].cnpj === sorted[0].cnpj;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    CNPJ
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.email - b.email);
                      const isReversed = novaLista[0].email === sorted[0].email;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    E-mail
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.celular - b.celular
                      );
                      const isReversed =
                        novaLista[0].celular === sorted[0].celular;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Celular
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.statusPedido - b.statusPedido
                      );
                      const isReversed =
                        novaLista[0].statusPedido === sorted[0].statusPedido;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Status
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {(!novaLista || novaLista?.length === 0) && (
                  <tr>
                    <td colSpan={tabelaColunas.length + 1}> Sem Registros </td>
                  </tr>
                )}
                {novaLista &&
                  novaLista?.map((data) => (
                    <tr key={data.id} style={{ whiteSpace: "nowrap" }}>
                      <td> {data.codigo.toString().padStart(6, "0")} </td>
                      <td> {data.codigoOportunidade} </td>
                      <td> {data.tp} </td>
                      <td> {data.dataCadastro} </td>
                      <td> {data.nomeCompleto} </td>
                      <td> {data.cnpj} </td>
                      <td> {data.email} </td>
                      <td> {data.celular} </td>
                      <td>
                        {" "}
                        {data.statusPedido === 1
                          ? "Pendente"
                          : "Concluído"}{" "}
                      </td>
                      <td className="text-right">
                        <div className="row">
                          <i
                            className="col-1 btn-edit-icon btn btn-icon fa fa-eye"
                            onClick={() => gotoDet(data.id)}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <TablePagination data={response} changePage={mudarPagina} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListGestaoPedidos;
